export default __webpack_public_path__ + "static/media/weather-pppp.27c54f8e.png";